define('app/sds/bar/prototype/sds-bar-prototype-constant',["service!selcomm", "$q"], function (selcomm, $q) {

	return Object.defineProperties({}, {
		activationRequested: {
			enumerable: true,
			get: function activationRequested_get() { return this.requested === "activate"; }
		},
		deactivationRequested: {
			enumerable: true,
			get: function deactivationRequested_get() { return this.requested === "deactivate"; }
		},
		errorOccured: {
			enumerable: true,
			get: function errorOccured_get() { return this.requested === "error"; }
		},
		serverMessage: {
			enumerable: true,
			get: function serverMessage_get() { return this.messageFromServer; }
		},
		requestDeactivation: {
			enumerable: true,
			get: function requestDeactivation_get() {
				return this.unbarRequest ? requestDeactivation : null;
			}
		},
		deactivationReasons: {
			enumerable: true,
			get: function deactivationReasons_get() {
				return this.unbarRequest ? this.unbarRequest.reasons : null;
			}
		},
		requestActivation: {
			enumerable: true,
			get: function requestActivation_get() {
				return this.barRequest ? requestActivation : null;
			}
		},
		activationReasons: {
			enumerable: true,
			get: function activationReasons_get() {
				return this.barRequest ? this.barRequest.reasons : null;
			}
		},
		request: {
			enumerable: true,
			get: function request_get() {
				return this.requestDeactivation && this.requestActivation ? null : this.requestDeactivation || this.requestActivation;
			}
		},
		reasons: {
			enumerable: true,
			get: function reasons_get() {
				return this.deactivationReasons && this.activationReasons ? null : this.deactivationReasons || this.activationReasons;
			}
		}
	});
	function requestDeactivation(serviceReferenceOrOptions) {
		//this.requested = "deactivate";
		var _this = this;
		var unbarDestination = angular.isObject(serviceReferenceOrOptions) ? serviceReferenceOrOptions : { ServiceReference: serviceReference };
		debugger;
		var promise = $q(function ($return, $throw) {
			selcomm.post("Service", "ServiceBarUnbarRequest", {
				serviceBarRequest: angular.extend({}, _this.unbarRequest, unbarDestination)
			}).then(function (barResponse) {
				switch (barResponse.Status) {
					case 0:
						_this.requested = "deactivate";
						$return(true);
						break;
					case 2:
						_this.requested = "error";
						$throw({
							code: barResponse.Status
						});
						break;
					default:
						_this.requested = "error";
						$return(false)
						break;
				}
				_this.messageFromServer = barResponse.Message;
			}).catch(function (barResponse) {
				_this.requested = "error";
				_this.messageFromServer = "Error occured! Please contact support.";
			});
		});
		return promise;
	}
	function requestActivation(serviceReferenceOrOptions) {
		var _this = this;
		var BarDestination = angular.isObject(serviceReferenceOrOptions) ? serviceReferenceOrOptions : { ServiceReference: serviceReference };
		var promise = $q(function ($return, $throw) {
			selcomm.post("Service", "ServiceBarUnbarRequest", {
				serviceBarRequest: angular.extend({}, _this.barRequest, BarDestination)
			}).then(function (barResponse) {
				switch (barResponse.Status) {
					case 0:
						_this.requested = "activate";
						$return(true);
						break;
					case 2:
						_this.requested = "error";
						$throw({
							code: barResponse.Status
						});
						break;
					default:
						_this.requested = "error";
						$return(false);
						break;
				}
				_this.messageFromServer = barResponse.Message;
			}).catch(function (barResponse) {
				_this.requested = "error";
				_this.messageFromServer = "Error occured! Please contact support.";
			});
		});
		return promise;
	}
});
